import { useContext } from "react";
import { ErrorDialogContext, errorHandledAsync } from "@/shared/context/error-context";
import { PutUsersIntegrationService } from "@/features/user/services/put-integration-service";
import { MoneyLinkWarning } from "@/shared/utils/custom-exception";


export const usePutUsersIntegration = () => {
  const putUsersIntegrationService = new PutUsersIntegrationService();

  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);

  const putUsersIntegration = async (
    ownerId: string,
    password: string
  ) => {
    try {
      await putUsersIntegrationService.putUsersIntegration({
        owner_id: ownerId,
        owner_pw: password
      });
      return true;
    } catch (error) {
      // エラー
      console.log("putUsersIntegration", error);
      setError(new MoneyLinkWarning({
        title: "ユーザーの統合に失敗しました",
        message: "入力情報を見直し、最初からお試しください。",
      }));
    } finally {
      //
    }
  };

  return {
    putUsersIntegration: errorHandledAsync(putUsersIntegration, setError),
  };
};
